import GenerateChart from './GenerateChart';

export default {
  extends: GenerateChart,
  props: {
    chartId: {
      default: 'doughnut-chart',
      type: String,
    },
    chartType: {
      type: String,
      default: 'doughnut',
    },
    datasets: {
      type: Array,
      default: [],
    },
    labels: {
      type: Array,
      default: [],
    },
    options: {
      type: Object,
      default: { responsive: true, maintainAspectRatio: false },
    },
  },
  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: this.datasets,
      },
      this.options
    );
  },
};
